import React, { PureComponent } from 'react'
import Isvg from 'react-inlinesvg'

import { localize } from 'helpers/translator'
import OverlayNotification from 'components/overlay_notification/overlay_notification'

import stopwatchSvg from 'assets/components/notification_box/stopwatch-icon.svg'

class TimesUpNotificationOverlay extends PureComponent {

	render() {
		const stopwatch = <Isvg styleName='' src={stopwatchSvg} cacheGetRequests={true} />
		const title = <span>{localize('activity_timer_timeIsUp')}</span>
		const text = <span>{localize('activity_timer_hangOn')}</span>

		return (
			<OverlayNotification color='blue' icon={stopwatch} title={title} text={text} />
		)
	}

}

TimesUpNotificationOverlay.propTypes = {

}

export default TimesUpNotificationOverlay
